var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on("click keyup", function (event) {
        if (event.type === "keyup") {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if (code !== 32 && code !== 13) {
                return false;
            }
        }
        handler.call(this, event);
    });
};

var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad() {
    // Add hcaptcha to all forms on a page
    jq(".h-captcha").each(function () {
        var form = jq(this).closest("form");
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            sitekey: window.hCaptchaSiteKey,
            callback: function (token) {
                jq("<input>", {
                    type: "hidden",
                    name: "h-captcha-response",
                    value: token,
                }).appendTo(form);
                form.submit();
            },
        });
    });
}

/**
 * Initializes validation for all forms with the "validate-form" class.
 * 
 * This function sets up custom validation rules, error handling, and submission logic
 * using the jQuery Validation plugin.
 */
function validate_forms() {
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr("id");
        jq(this).validate({
            errorElement: "span",
            errorClass: "error eq-error",
            rules: {
                password_confirm: {
                    equalTo: "#password"
                }
            },
            messages: {
                password_confirm: {
                    equalTo: "Passwords must be the same"
                }
            },
            errorPlacement: function (error, element) {
                var elementId = element.attr("id");
                var errorId = elementId + "-error";
                element.attr("aria-describedby", errorId);
                element.attr("aria-invalid", "true");

                if (element.attr("type") === "radio") {
                    error.prependTo(element.parent());
                } else {
                    error.appendTo(element.parent());
                }
            },
            success: function (label) {
                // Remove the error message on successful validation
                var elementId = label.attr("id").replace('-error', '');
                var errorId = elementId + "-error";
                var inputElement = jq('#' + elementId);
                
                inputElement.removeAttr("aria-describedby");
                inputElement.removeAttr("aria-invalid");
                label.remove();
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form
            invalidHandler: function (event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: "instant", block: "center" });
                    errorElement.focus();
                }
            },
        });
    });

    // Custom email validation method
    jq.validator.methods.email = function (value, element) {
        return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    };
}

/**
 * Focus form messages for accessibility
 * Automatically focuses form message containers (success or error) when page loads
 * to ensure screen readers announce the message
 * 
 * Focuses the first visible child element (skips sr-only) to avoid JAWS page title reading issues
 */
function focusFormMessage() {
    // Helper function to find first child that's not sr-only
    function findFirstVisibleChild(container) {
        let child = container.firstElementChild;
        while (child) {
            // Skip elements with sr-only class
            if (!child.classList.contains('sr-only')) {
                return child;
            }
            child = child.nextElementSibling;
        }
        return null;
    }
    
    // Check for thank you messages (redirect pages)
    const thankYouMessage = document.getElementById('thank-you-message');
    if (thankYouMessage) {
        requestAnimationFrame(function() {
            const firstVisibleChild = findFirstVisibleChild(thankYouMessage);
            const elementToFocus = firstVisibleChild || thankYouMessage;
            
            if (!elementToFocus.hasAttribute('tabindex')) {
                elementToFocus.setAttribute('tabindex', '0');
            }
            
            elementToFocus.focus();
            elementToFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return;
    }
    
    // Check for inline form messages (email alerts, etc.)
    const formMessage = document.getElementById('form-message');
    if (formMessage) {
        requestAnimationFrame(function() {
            const firstVisibleChild = findFirstVisibleChild(formMessage);
            const elementToFocus = firstVisibleChild || formMessage;
            
            if (!elementToFocus.hasAttribute('tabindex')) {
                elementToFocus.setAttribute('tabindex', '0');
            }
            
            elementToFocus.focus();
            elementToFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }
}

// Main document ready scripts
jq(document).ready(function () {
    // Basic Form Validation
    validate_forms();
    
    // Focus form messages for accessibility
    focusFormMessage();

    // Restore focus to filter control after filter-triggered reload (2.4.3 Focus Order)
    // Preserves linkable filtered states when opening a URL with focus= (e.g. shared link).
    (function () {
        var params = new URLSearchParams(window.location.search);
        var focusId = params.get("focus");
        if (focusId) {
            var el = document.getElementById(focusId);
            if (el && (el.tagName === "SELECT" || el.tagName === "INPUT" || el.getAttribute("role") === "combobox")) {
                requestAnimationFrame(function () {
                    el.focus();
                    el.scrollIntoView({ behavior: "smooth", block: "center" });
                });
                params.delete("focus");
                var newSearch = params.toString();
                var newUrl = window.location.pathname + (newSearch ? "?" + newSearch : "") + window.location.hash;
                if (window.history.replaceState) {
                    window.history.replaceState({}, "", newUrl);
                }
            }
        }
    })();

    // Pagination
    const paginationMobile = jq("#pagination--mobile");
    if (paginationMobile.length) {
        jq(this)
            .find("#pagination--mobile-select")
            .change(function () {
                var selectedPage = jq(this).val();
                location.href = encodeURI(selectedPage);
            });
    }

    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr("rel");
        if (!linkRel || (linkRel && linkRel.indexOf("noopener") == -1)) {
            var newRel = linkRel === undefined ? "" : linkRel;
            newRel += linkRel && linkRel.length ? " noopener" : "noopener";
            jq(this).attr("rel", newRel);
        }
        // Add descriptive text for screen readers if there's not already a title attr set
        if (this.getAttribute("title") === null) {
            this.setAttribute("title", "Opens in a new window");
        }
    });
    addRequiredAsteriskToLabels();

    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    var mainContent = document.getElementById("mainContent");
    
    // If #mainContent doesn't exist, hide #scroll-more
    if (!mainContent && scrollMore) {
        scrollMore.style.display = "none";
    } else if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
    
            // Adjust scroll offset based on header height
            let header = document.querySelector("#site-header");
            var animationDistance =
                window.innerWidth <= 991 &&
                header &&
                window.getComputedStyle(header).getPropertyValue("position") !== "fixed"
                    ? 0
                    : jq("#site-header").outerHeight();
    
            // On the home layout the hero lives inside #mainContent; use the anchor when present.
            var scrollTarget = document.getElementById("scroll-more-anchor") || mainContent;
    
            jq("html, body").animate(
                {
                    scrollTop: jq(scrollTarget).offset().top - animationDistance,
                },
                "slow"
            );
        });
    }

    // Affix replacement - adds .affix class on scroll (replaces Bootstrap 3 affix plugin)
    var subNav = jq(".sub-navigation.affixed");
    if (subNav.length) {
        var subNavWrapper = subNav.closest(".sub-navigation-wrapper");
        var headerHeight = jq("#site-header").outerHeight() || 130;
        
        // Calculate the offset - when the sub-nav wrapper top reaches the header bottom
        var subNavOffsetTop = subNavWrapper.length ? subNavWrapper.offset().top : subNav.offset().top;
        var affixOffset = subNavOffsetTop - headerHeight;
        
        jq(window).on("scroll", function() {
            var scrollTop = jq(window).scrollTop();
            if (scrollTop >= affixOffset) {
                subNav.addClass("affix");
            } else {
                subNav.removeClass("affix");
            }
        });
        
        // Recalculate on resize
        jq(window).on("resize", function() {
            headerHeight = jq("#site-header").outerHeight() || 130;
            subNavOffsetTop = subNavWrapper.length ? subNavWrapper.offset().top : subNav.offset().top;
            affixOffset = subNavOffsetTop - headerHeight;
        });
        
        // Trigger once on load
        jq(window).trigger("scroll");
    }

    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if (divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                        svgElm = jq(this).find(".circle"),
                        percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({ percentage: 0 })
                        .stop(true)
                        .animate(
                            { percentage: percentNumber },
                            {
                                duration: 2000,
                                step: function () {
                                    var percentageVal = Math.round(this.percentage);
                                    percDiv.text(percentageVal + "%");
                                },
                            }
                        )
                        .promise()
                        .done(function () {
                            percDiv.text(percentNumber + "%");
                        });
                });
                jq(document).unbind("scroll");
            }
        });
    }

    var menuRight = document.getElementById("main-nav"),
        showRight = document.getElementById("showRight");

    function getMenuFromTrigger(trigger) {
        if (!trigger || !trigger.getAttribute) return { panel: menuRight, trigger: showRight };
        var panelId = trigger.getAttribute("aria-controls");
        return {
            panel: panelId ? document.getElementById(panelId) : menuRight,
            trigger: trigger
        };
    }

    function getOpenMenuPair() {
        var openPanel = document.querySelector(".cbp-spmenu.cbp-spmenu-open");
        if (!openPanel) return { panel: menuRight, trigger: showRight };
        var panelId = openPanel.id;
        var trigger = panelId ? document.querySelector("[aria-controls=\"" + panelId + "\"]") : showRight;
        return { panel: openPanel, trigger: trigger || showRight };
    }

    jq.fn.openMobileRightMenu = function (triggerEl) {
        var pair = triggerEl ? getMenuFromTrigger(triggerEl) : getOpenMenuPair();
        var activePanel = pair.panel;
        var activeTrigger = pair.trigger;
        toggleMenuKeybind(activePanel, activeTrigger);
        jq(activeTrigger).toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(activePanel).toggleClass("cbp-spmenu-open");
        if (activeTrigger !== showRight) {
            jq(showRight).toggleClass("disabled");
        }
        if (jq(activeTrigger).hasClass("active")) {
            jq(activeTrigger).attr("aria-label", "Close main navigation");
            jq(activeTrigger).attr("aria-expanded", "true");
        } else {
            jq(activeTrigger).attr("aria-label", "Expand main navigation");
            jq(activeTrigger).attr("aria-expanded", "false");
        }
    };

    // Disable menu toggle when a link is clicked.
    // A closed parent with children expands on the first tap instead of navigating.
    jq(".main-menu a").on("click", function () {
        if (window.innerWidth < 992 && this.parentElement.classList.contains("has-children") && !this.parentElement.classList.contains("open")) {
            return;
        }
        var openPanel = document.querySelector(".cbp-spmenu.cbp-spmenu-open");
        if (openPanel && jq(this).closest(".cbp-spmenu").length) {
            var trigger = document.querySelector("[aria-controls=\"" + openPanel.id + "\"]");
            if (trigger) {
                jq(trigger).removeClass("active");
                jq("body").removeClass("push-to-left");
                jq(openPanel).removeClass("cbp-spmenu-open");
            }
        }
    });

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }

    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
    function toggleMenuKeybind(activePanel, activeTrigger) {
        activePanel = activePanel || menuRight;
        activeTrigger = activeTrigger || showRight;
        var $body = jq("body");
        if ($body.hasClass("push-to-left")) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(activeTrigger).toggleClass("active");
                    jq("body").toggleClass("push-to-left");
                    jq(activePanel).toggleClass("cbp-spmenu-open");
                    if (activeTrigger !== showRight) {
                        jq(showRight).removeClass("disabled");
                    }
                    $body.off("keydown");
                }
            });
        }
    }

    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e) {
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length - 1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // Filter updates via AJAX with linkable URLs (pushState). Preserves focus on the control that was changed (2.4.3 Focus Order).
    (function () {
        function fetchAndReplace(containerId, url, focusEl, shouldPushState) {
            var container = document.getElementById(containerId);
            if (!container) return;
            fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
                .then(function (response) {
                    if (!response.ok) { throw new Error("Network response was not ok"); }
                    return response.text();
                })
                .then(function (html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");
                    var newContent = doc.getElementById(containerId);
                    if (newContent) {
                        container.innerHTML = newContent.innerHTML;
                        if (shouldPushState !== false && window.history.pushState) {
                            window.history.pushState({ filterContainer: containerId }, "", url);
                        }
                        if (focusEl && (focusEl.tagName === "SELECT" || focusEl.tagName === "INPUT" || focusEl.getAttribute("role") === "combobox")) {
                            requestAnimationFrame(function () {
                                focusEl.focus();
                                focusEl.scrollIntoView({ behavior: "smooth", block: "center" });
                            });
                        }
                    } else {
                        window.location.href = url;
                    }
                })
                .catch(function () {
                    window.location.href = url;
                });
        }

        function setSelectsFromParams(params) {
            jq(".row-filter .eq-select").each(function () {
                var name = jq(this).attr("name");
                var val = params.get(name);
                if (name === "year") {
                    jq(this).val(val != null && val !== "" ? val : "-1");
                } else if (name === "category") {
                    jq(this).val(val != null ? val : "all");
                } else if (val != null) {
                    jq(this).val(val);
                }
            });
            jq("#sec-filing-filter select").each(function () {
                var name = jq(this).attr("name");
                var val = params.get(name);
                jq(this).val(val != null ? val : "");
            });
        }

        function syncUrlToFilterState() {
            var params = new URLSearchParams(window.location.search);
            var results = document.getElementById("row-filter-results");
            if (results) {
                setSelectsFromParams(params);
                var base = window.location.origin + window.location.pathname;
                var rowQs = params.toString();
                fetchAndReplace("row-filter-results", base + (rowQs ? "?" + rowQs : ""), null, false);
                return;
            }
            var secResults = document.getElementById("sec-filing-results");
            if (secResults) {
                var form = document.getElementById("sec-filing-filter");
                if (form) {
                    setSelectsFromParams(params);
                    var formUrl = form.action || window.location.href.split("?")[0];
                    var secQs = params.toString();
                    fetchAndReplace("sec-filing-results", formUrl + (secQs ? "?" + secQs : ""), null, false);
                }
            }
        }

        // SEC Filing Filters - AJAX update with linkable URL
        jq("#sec-filing-filter select").on("change", function (e) {
            e.preventDefault();
            var form = jq(this).closest("form");
            var formUrl = form.attr("action") || (window.location.origin + window.location.pathname);
            var params = new URLSearchParams(new FormData(form[0]));
            var qs = params.toString();
            var url = formUrl + (qs ? "?" + qs : "");
            var focusEl = this;
            fetchAndReplace("sec-filing-results", url, focusEl);
        });

        // Row-filter (IR News / Press Releases) - AJAX update with linkable URL
        var $filterSelect = jq(".row-filter .eq-select");
        if ($filterSelect.length) {
            $filterSelect.on("change", function () {
                var base = window.location.origin + window.location.pathname;
                var query = "";
                jq(".row-filter .eq-select").each(function () {
                    var val = jq(this).val();
                    if (val != null && val !== "" && val !== "-1") {
                        query += (query ? "&" : "?") + encodeURIComponent(jq(this).attr("name")) + "=" + encodeURIComponent(val);
                    }
                });
                var url = base + query;
                var focusEl = this;
                fetchAndReplace("row-filter-results", url, focusEl);
            });
        }

        // Back/forward: restore content for current URL so linkable filter state works
        jq(window).on("popstate", function (e) {
            var state = e.originalEvent.state;
            if ((state && state.filterContainer) || (!state && window.location.search)) {
                syncUrlToFilterState();
            }
        });
    })();

    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }

    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
        jq(this).next(".spr-expandable").toggle("blind");
        jq(this).toggleClass("expanded");
        if (jq(this).hasClass("expanded")) {
            jq(this).attr("aria-pressed", true);
        } else {
            jq(this).attr("aria-pressed", false);
        }
    });

    // Crisis Messaging
    var $majorAnnouncement = jq("#majorAnnouncement");
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            let announcements = new EqDialog({
                show_close_button: true,
            });
            announcements.open("inline", "majorAnnouncement");
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }

    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) {
        jq("body").addClass("scrollbar");
    }

    // Mobile submenus start aria-hidden with tabindex -1. An open branch has to undo that or keyboard users cannot reach it.
    function syncMobileSubmenuAccess(li) {
        var submenu = li.querySelector(":scope > ul");
        if (!submenu) return;
        var open = li.classList.contains("open");
        submenu.setAttribute("aria-hidden", open ? "false" : "true");
        var links = submenu.querySelectorAll(":scope > li > a");
        for (var i = 0; i < links.length; i++) {
            links[i].setAttribute("tabindex", open ? "0" : "-1");
        }
    }

    function syncOpenMobileSubmenus() {
        if (window.innerWidth > 991) return;
        var openItems = document.querySelectorAll(".main-menu li.has-children.open");
        for (var i = 0; i < openItems.length; i++) {
            syncMobileSubmenuAccess(openItems[i]);
        }
    }

    function resize_events() {
        // Fix accessibility issue for main navigation and sub navigation triggers on mobile
        if (window.innerWidth <= 991) {
            jq(".mobile-nav-trigger").attr("tabindex", 0);
            jq(".mobile-sub-nav-trigger").attr("tabindex", 0);
            jq(".has-children ul li a").attr("tabindex", "-1");
            jq(".cbp-spmenu > .main-menu ul").attr("aria-hidden", "true");
            jq(".has-children ul").attr("aria-hidden", "true");
            jq(".cbp-spmenu > .main-menu > li > ul").attr("aria-hidden", "true");
            if (jq(".cbp-spmenu").hasClass("cbp-spmenu-open")) {
                jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", 0);
            } else {
                jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", -1);
            }
            syncOpenMobileSubmenus();
        } else {
            jq(".mobile-nav-trigger").attr("tabindex", "");
            jq(".mobile-sub-nav-trigger").attr("tabindex", "");
            jq(".has-children ul li a").attr("tabindex", "");
            jq(".has-children ul").attr("aria-hidden", "false");
            jq(".cbp-spmenu > .main-menu > li > ul").attr("aria-hidden", "false");
            jq(".cbp-spmenu > .main-menu > li > a").attr("tabindex", 0);
        }
    }
 
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function (evt) {
        resize_events();
    });

    // Enable accessible clicking on mobile navs and subnavs (supports integrated-site mobile header)
    jq(".mobile-nav-trigger").on("click", function (evt) {
        evt.stopPropagation();
        jq(this).openMobileRightMenu(this);
        resize_events();
        return false;
    });
    // Close mobile nav when selecting the darkened body background
    jq(".cbp-spmenu").accessibleClick(function (evt) {
        evt.stopPropagation();
    });
    jq("body").on("click", function (evt) {
        if (this.classList.contains("push-to-left")) {
            jq(this).openMobileRightMenu(); /* no arg: close whichever menu is open */
            resize_events();
            return false;
        }
    });

    // Detect window size change (switching to landscape on tablet
    var windowW = window.innerWidth;
    jq(window).resize(function () {
        windowW = window.innerWidth;
    });

    // Mobile: first tap on a parent expands its submenu. A second tap follows the link.
    jq(".main-menu li.has-children > a").accessibleClick(function (e) {
        if (windowW >= 992) return;
        var li = this.parentElement;
        if (li.classList.contains("open")) {
            // Enter fires click, then keyup. The click already opened this branch;
            // stop the trailing keyup so the drawer-close handler does not run.
            if (e.type === "keyup") {
                e.stopImmediatePropagation();
            }
            return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        jq(li).siblings(".has-children.open").each(function () {
            this.classList.remove("open");
            var siblingLink = this.querySelector(":scope > a");
            if (siblingLink) siblingLink.setAttribute("aria-expanded", "false");
            syncMobileSubmenuAccess(this);
        });
        li.classList.add("open");
        this.setAttribute("aria-expanded", "true");
        syncMobileSubmenuAccess(li);
    });

    jq(".main-menu li.has-children").on("mouseenter focusin", function () {
        if (window.innerWidth < 992) return;
        var link = this.querySelector(":scope > a");
        if (link) link.setAttribute("aria-expanded", "true");
    }).on("mouseleave focusout", function (e) {
        if (window.innerWidth < 992) return;
        if (e.type === "focusout") {
            if (this.contains(e.relatedTarget) || this.matches(":hover")) return;
        } else if (this.contains(document.activeElement)) {
            return;
        }
        var link = this.querySelector(":scope > a");
        if (link) link.setAttribute("aria-expanded", "false");
    });

    jq(".main-menu > li > ul > li.has-children").on("mouseenter focusin", function () {
        if (window.innerWidth < 992) return;
        var rect = this.getBoundingClientRect();
        var sub = this.querySelector(":scope > ul");
        var w = sub ? (sub.offsetWidth || 310) : 310;
        if (rect.right + w > window.innerWidth - 8) {
            this.classList.add("flyout-left");
        } else {
            this.classList.remove("flyout-left");
        }
    });

    jq("#main-nav ul a, #mobile-nav-integrated ul a").accessibleClick(function (e) {
        if (windowW >= 992) return;
        if (this.parentElement.classList.contains("has-children") && !this.parentElement.classList.contains("open")) {
            return;
        }
        var panel = jq(this).closest(".cbp-spmenu").get(0);
        var trigger = panel && panel.id ? document.querySelector("[aria-controls=\"" + panel.id + "\"]") : null;
        if (panel) jq(panel).removeClass("cbp-spmenu-open");
        jq("body").removeClass("push-to-left");
        if (trigger) jq(trigger).removeClass("active");
    });


    //Accessible click for Financial Results collapse elements
    jq(".quarterly-results [role=button]").accessibleClick(function (evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != "click") {
            jq(this).click();
            return false;
        }
    });

    //Expand/Collapse all button for Financial Results
    var FinancialResultsExpandBtn = jq(".expand-all-quarters");
    var QuarterHeaders = jq(".quarterly-results .header");

    FinancialResultsExpandBtn.on("click", function (e) {
        //If elements are collapsed, expand the rest
        if (jq(this).text() == "Expand All") {
            QuarterHeaders.filter(".collapsed").click();
        } else {
            //Otherwise collapse them all
            QuarterHeaders.filter(":not(collapsed)").click();
        }
    });

    QuarterHeaders.on("click", function (e) {
        if (FinancialResultsExpandBtn.length) {
            //Allow for collapse animation to complete
            //setTimeout(functionRef, delay, param1, param2)
            setTimeout(updateExpandBtnText, 200, FinancialResultsExpandBtn, ".quarterly-results .header");
        }
    });

    // Allows upload of cover letter via styled link by triggering hidden upload/input field
    jq("#cover_letter").on("click", function (e) {
        e.preventDefault();
        jq("#upload_cover_letter:hidden").trigger("click");
    });

    // Chart Library Functionality
    jq(".chart-table-expander").on("click", function (e) {
        e.target.classList.toggle("hidden");
        e.target.parentElement.querySelector(".chart-legend").classList.toggle("hidden");
    });

    // Remove width from table headers with only a superscript
    jq(".report .th").each(function () {
        // Extract the innerHTML
        const innerContent = jq(this).html().trim();

        // Use a regex to check if content matches <sup> with a number, asterisk, or these wrapped in square brackets
        const regex = /^<sup>(\[\d+\]|\d+|\[\*\]|\*)<\/sup>$/;
        if (regex.test(innerContent)) {
            jq(this).css({
                width: "0%",
                "padding-left": "0",
            });
        }
    });

    /**
     * Accessibility Fix for Radio Inputs
     **/
    let radioLabels = document.querySelectorAll(".eq-radio label");

    radioLabels.forEach(function (radioLabel) {
        radioLabel.setAttribute("tabindex", "0"); // Ensure labels are focusable

        radioLabel.addEventListener("keydown", function (e) {
            // Check if the key pressed is the spacebar
            if (e.key === " " || e.keyCode === 32) {
                e.preventDefault();
                let associatedRadio = document.getElementById(this.getAttribute("for"));
                // Check if the associated radio button exists and is not already checked
                if (associatedRadio && !associatedRadio.checked) {
                    associatedRadio.checked = true;
                    associatedRadio.dispatchEvent(new Event("change"));
                }
            }
        });
    });
    // MOBILE MENU TRAP FOCUS
    let lastNavItem = jq(".main-menu > li:last-child > a");
    let mobileTrigger = jq(".mobile-nav-trigger");
    // Normal Tab
    lastNavItem.on("keydown", function (e) {
        if (!e.shiftKey && e.key === "Tab" && mobileTrigger.hasClass("active")) {
            e.preventDefault();
            mobileTrigger.focus();
        }
    });
    // Shift + Tab
    mobileTrigger.on("keydown", function (e) {
        if (e.shiftKey && e.key === "Tab" && mobileTrigger.hasClass("active")) {
            e.preventDefault();
            lastNavItem.focus();
        }
    });
    //CCPA Request Form
    jq('#ccpa-request-form input[name="claim"]').change(function () {
        let value = jq(this).val();
        if (value == "Resident") {
            jq(".show-resident").removeClass("hide");
            jq(".show-representative").addClass("hide");
            jq("#certify_resident").addClass("required");
            jq("#certify_resident").attr("aria-required", "true");
            jq(".show-representative .conditional-required, #certify_representative").removeClass("required");
            jq(".show-representative .conditional-required, #certify_representative").removeClass("error");
            jq(".show-representative .conditional-required, #certify_representative").removeAttr("aria-required");
        } else if (value == "Representative") {
            jq(".show-representative").removeClass("hide");
            jq(".show-resident").addClass("hide");
            jq("#certify_resident").removeClass("required");
            jq("#certify_resident").removeClass("error");
            jq("#certify_resident").removeAttr("aria-required");
            jq(".show-representative .conditional-required, #certify_representative").addClass("required");
            jq(".show-representative .conditional-required, #certify_representative").attr("aria-required", "true");
        }
    });

    //Check for multiple forms and update ids to avoid duplicates
    let forms = jq("form");
    if (forms.length > 1) {
        const idCounts = {};
        forms.each(function (formIndex, form) {
            // Find all input elements within the form
            jq(form)
                .find("input")
                .each(function (inputIndex, input) {
                    const currentId = jq(input).attr("id");
                    if (currentId) {
                        // Generate a unique ID if there is a duplicate
                        if (!idCounts[currentId]) {
                            idCounts[currentId] = 0;
                        }
                        idCounts[currentId]++;
                        const uniqueId = `${currentId}_${formIndex}`;

                        // Update the input's id attribute to be unique
                        jq(input).attr("id", uniqueId);

                        // Update the corresponding label's for attribute
                        jq(form).find(`label[for="${currentId}"]`).attr("for", uniqueId);
                    }
                });
        });
    }

    jq(".collapse").on("shown.bs.collapse", function (event) {
        // Get the content element within the collapsed section
        let contentElement = jq(this).find(".text")[0];

        if (contentElement) {
            // Check if the content is not in the viewport before scrolling
            if (!isElementInViewport(contentElement)) {
                // Scroll to reveal the content
                contentElement.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                    inline: "nearest",
                });
            }
        }
    });

    // Initialize dialogs
    let eq_dialogs = new EqDialog();
    eq_dialogs.init();
    
    //email alerts button eventlistener
    // Note: In Bootstrap 5, aria-expanded is updated BEFORE click handlers run,
    // so we check for 'true' (meaning it just opened)
    document.querySelector('.btn[href="#email-alerts-cta-form"]')?.addEventListener('click', function() {
        if (this.getAttribute('aria-expanded') === 'true') {
            const header = document.getElementById('header');
            const navHeight = (header ? header.offsetHeight : 0) + 20;
            const buttonTop = this.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: buttonTop - navHeight,
              behavior: 'smooth'
            });
        }
    });
    
}); // end document.ready

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required")
        .siblings("label")
        .each(function () {
            let currentText = jq(this).text();
            jq(this).text(currentText + "*");
        });
}

/**
 * addCustomErrorFormHandlers
 *
 * Sets up custom error handling for forms, specifically targeting required
 * checkboxes and radio button groups. Displays error messages and applies
 * border styling to elements that fail validation. Enhances accessibility by
 * updating ARIA attributes based on user interactions.
 *
 * - Applies different border colors for elements within dark-themed sections.
 * - Adds or removes error messages and styles based on validation results.
 * - Updates ARIA attributes for better accessibility.
 */

function addCustomErrorFormHandlers() {
    const BORDER_COLOR_LIGHT = "#D40033";
    const BORDER_COLOR_DARK = "#FA003A";

    // Listen for form submission
    jq("form").on("submit", function (e) {
        jq("ul.checkboxes.required, ul.radios.required").each(function () {
            let type = jq(this).hasClass("checkboxes") ? "checkbox" : "radio";
            let borderColor = jq(this).closest(".dark").length > 0 ? BORDER_COLOR_DARK : BORDER_COLOR_LIGHT;

            // Check if any input of the correct type in this group is checked
            if (jq(this).find('input[type="' + type + '"]:checked').length === 0) {
                jq(this).css("border", "1px solid " + borderColor);

                // Link error to checkbox/radio group
                let errorId = jq(this).parent().attr("aria-labelledby") + "-error";
                jq(this).parent().attr("aria-describedby", errorId);

                // Add error message if it does not already exist
                if (jq(this).siblings(".eq-error").length === 0) {
                    jq(this).after(`<span class="eq-error" id="${errorId}">This field is required</span>`);
                }
            } else {
                // Remove the border and error message if any input is checked
                jq(this).css("border", "");
                jq(this).siblings(".eq-error").remove();
                jq(this).parent().removeAttr("aria-describedby");
            }
        });
    });

    // Event handler for changes to checkboxes and radio buttons in all groups
    jq(document).on("change", 'ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]', function () {
        let ul = jq(this).closest("ul.checkboxes, ul.radios");

        // Update ARIA attributes for accessibility
        if (jq(this).attr("type") === "radio") {
            // Set aria-checked for all radio buttons in the group
            ul.find('input[type="radio"]').attr("aria-checked", "false");
            jq(this).attr("aria-checked", "true");
        } else {
            jq(this).attr("aria-checked", this.checked);
        }

        // Check if any input in this group is checked
        if (ul.find("input:checked").length > 0) {
            // If an input is checked, remove the border and error message
            ul.css("border", "");
            ul.siblings(".eq-error").remove();
        }
    });

    // Initialize ARIA attributes on page load
    jq('ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]').each(function () {
        jq(this).attr("aria-checked", this.checked);
    });
}

// Call the function to setup event handlers once the document is ready
jq(document).ready(function () {
    addCustomErrorFormHandlers();
});

//SMOOTH SCROLL
// Scrolling when accesing an URL with a hash in there
let windowLocationHash = window.location.hash;
if (windowLocationHash.length) {
    let hashElement = jq(windowLocationHash);
    if (hashElement.length) {
        let offset = 0;
        let header = jq("#site-header");
        let subNav = jq(".sub-navigation");
        if (header.length) {
            offset += header.outerHeight();
        }
        if (subNav.length) {
            offset += subNav.outerHeight();
        }
        if (hashElement.hasClass("footnote-desc")) {
            offset += 20;
        }
        jq("html,body").animate(
            {
                scrollTop: hashElement.offset().top - offset,
            },
            300
        );
    }
}
// Smooth scroll animation when a link containing # in the href is clicked
jq(document).on("click", 'a[href*="#"]', function (event) {
    // Check for any anchor links we want to ignore
    if (jq(this).hasClass("chart-legend-trigger") || jq(this).hasClass("accordion-btn") || jq(this).hasClass("eq-dialog") || jq(this).hasClass("footnote-link") || jq(this).hasClass("footnote-backlink") || jq(this).closest(".tab-header").length || (jq(this).hasClass("span-asterisk") && jq(this).closest(".metrics-stats-footnotes").length)) {
        return; // Exit the function early if ignored links are found
    }

    // Check if the href contains #
    if (this.hash !== "") {
        let hash = this.hash;
        let id = hash.split("#")[1];
        let el = document.getElementById(id);

        if (!el) {
            return;
        }

        let linkUrl;

        try {
            linkUrl = new URL(this.href, window.location.href);
        } catch (error) {
            return;
        }

        // Prevent native anchor scroll when staying on the current page
        if (linkUrl.pathname === window.location.pathname) {
            event.preventDefault();
        } else {
            return;
        }

        // Call the named function smoothScrollToHash for regular anchor links
        // If the target is a collapsed box, wait for it to open
        if (el.classList.contains("panel-collapse")) {
            setTimeout(() => {
                smoothScrollToHash(hash);
            }, 100);
        } else {
            smoothScrollToHash(hash);
        }

        // Skip links only scroll otherwise; move keyboard/AT focus to the target
        // (targets carry tabindex="-1") so "Skip to…" actually lands the user there.
        if (jq(this).closest("#skipLinks, #skipLinksIntegratedMobile").length) {
            if (!el.hasAttribute("tabindex")) {
                el.setAttribute("tabindex", "-1");
            }
            el.focus({ preventScroll: true });
        }
    }
});
function smoothScrollToHash(hash) {
    if (hash.length) {
        let hashElement = jq(hash);
        if (hashElement.length) {
            let offset = 0;
            let header = jq("#site-header");
            let subNav = jq(".sub-navigation");
            if (header.length) {
                offset += header.outerHeight();
            }
            if (subNav.length) {
                offset += subNav.outerHeight();
            }
            if (hashElement.hasClass("footnote-desc")) {
                offset += 20;
            }
            jq("html,body").animate(
                {
                    scrollTop: hashElement.offset().top - offset,
                },
                800
            );
        }
    }
}

//Check if any target elements are collapsed
function elementsAreCollapsed(selector = "[data-bs-toggle='collapse']") {
    if (jq(selector + ".collapsed").length) {
        return true;
    } else {
        return false;
    }
}

function updateExpandBtnText(btn, collapseTarget) {
    if (!btn) {
        return;
    }
    if (elementsAreCollapsed(collapseTarget)) {
        btn.text("Expand All");
    } else {
        btn.text("Collapse All");
    }
}

// Checkbox Groups - SEC Filings: parent "All SEC Filings" and child checkboxes
// Parent when checked: check all children but do NOT disable them (accessibility: users can see/change child state).
// Parent is never auto-checked when user manually checks all four children; aria-checked="mixed" reflects partial/full child selection.

function updateSecParentAriaChecked(parentCheckbox) {
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");
    const checkedCount = childCheckboxes.filter(":checked").length;
    const total = childCheckboxes.length;
    if (parentCheckbox.is(":checked")) {
        parentCheckbox.attr("aria-checked", "true");
    } else if (checkedCount === 0) {
        parentCheckbox.attr("aria-checked", "false");
    } else {
        parentCheckbox.attr("aria-checked", "mixed");
    }
}

function initSecFilingsAriaChecked() {
    jq('[id^=ir-sec-all]').each(function () {
        const parentCheckbox = jq(this);
        const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");
        // Ensure children are never disabled so users can always see/change child state (accessibility)
        childCheckboxes.prop("disabled", false);
        updateSecParentAriaChecked(parentCheckbox);
    });
}

jq('[id^=ir-sec-all]').change(function () {
    const parentCheckbox = jq(this);
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");

    if (parentCheckbox.is(":checked")) {
        // Check all children; do not disable so users can see and change child state (accessibility)
        childCheckboxes
            .prop("checked", true)
            .prop("disabled", false)
            .attr("aria-checked", "true");
    } else {
        childCheckboxes
            .prop("checked", false)
            .prop("disabled", false)
            .attr("aria-checked", "false");
    }
    updateSecParentAriaChecked(parentCheckbox);
});

// Uncheck parent when any child is unchecked (saving must reflect actual selection - no regression).
// Do NOT auto-check parent when all four children are manually checked; use aria-checked="mixed" when some or all children selected.
jq(".ir-sec-sub").change(function () {
    const parentCheckbox = jq(this).closest("ul").parent().find("input[id^=ir-sec-all]");

    if (!jq(this).is(":checked")) {
        parentCheckbox.prop("checked", false);
    }
    updateSecParentAriaChecked(parentCheckbox);
});

jq(document).ready(function () {
    initSecFilingsAriaChecked();
});

// Timeline — match wrapper height to card content on tablet/desktop only
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) {
                jq(".point-wrapper").css("height", "");
                return;
            }
            // Even spacing: every slot in a timeline gets the SAME height,
            // sized to the tallest card (incl. image items), so the gaps
            // between items are uniform regardless of content.
            jq(".module-timeline").each(function () {
                var $wrappers = jq(this).find(".point-wrapper");
                var maxHeight = 0;
                $wrappers.each(function () {
                    var h = jq(this).find(".point").outerHeight();
                    if (h > maxHeight) {
                        maxHeight = h;
                    }
                });
                $wrappers.css("height", maxHeight / 1.6);
            });
        },
    };
    var resizeTimer;
    jq(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    // Recalc once images have loaded so their height is included in the max.
    jq(window).on("load", timeline.resizePoints);
    timeline.resizePoints();
}

//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) {
        jq("body").addClass("scrollbar");
    } else {
        jq("body").removeClass("scrollbar");
    }
});
// Scroll More CTA templates
var scrollMore = document.getElementById("scroll-more-alt");
if (scrollMore) {
    jq(scrollMore).accessibleClick(function (e) {
        e.preventDefault();
        var target = jq("#scroll-more-anchor");
        jq("html,body").animate(
            {
                scrollTop: target.offset().top - jq("#site-header").height(),
            },
            "slow"
        );
    });
}
/**
 * Balance Sheet Page - Income Statement Page - Cash Flow Page
 *
 * Replaces <a> elements within report table with <span> elements.
 * Removes 'href' and 'onclick' attributes from these elements &
 * adds the original 'a' class back to it.
 */
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".report")) {
        // Find the table with class 'report'
        const reportTable = document.querySelector(".report");

        if (reportTable) {
            // Find all <td> elements containing <a> elements
            const tdWithLinks = reportTable.querySelectorAll("td a");

            // Transform each <a> into a <span>
            tdWithLinks.forEach((aElement) => {
                const span = document.createElement("span");
                span.innerHTML = aElement.innerHTML;
                aElement.parentNode.replaceChild(span, aElement);
                span.classList.add("a");
            });
        }
    }
});

// Accesibility Form
let formCounter = 0;
jq(".add-request").accessibleClick(function () {
    formCounter++;
    let newFields = '<div class="info-block">' + '<div class="form-group">' + '<label for="url-' + formCounter + '">URL of requested document or webpage:</label>' + '<input type="text" name="url-' + formCounter + '" id="url-' + formCounter + '" value="" class="required form-control" placeholder="ex. https://www.website.com/page" />' + "</div>" + '<div class="form-group">' + '<label for="description-' + formCounter + '">Description of request or issue related to URL:</label>' + '<textarea name="description-' + formCounter + '" id="description-' + formCounter + '" value="" class="required form-control" placeholder="Enter a description of your request or issue related to the URL inputted above"></textarea>' + "</div>" + "</div>";
    jq(".request-info").append(newFields);
    jq("#url-" + formCounter).focus();
});

/**
 * Global - Decorative Image Alt Check
 *
 * This will check all images across the site to see if the image has a
 * empty or missing alt attribute. If so, aria-hidden="true" will be set.
 */
jq("img").each((ind, el) => {
    // Check if the image has empty or no alt attribute
    if (!jq(el).attr("alt") || jq(el).attr("alt").trim() === "") {
        // If the alt text is empty or not present, set aria-hidden="true"
        jq(el).attr("aria-hidden", "true");
    }
});

/**
 * Row Scripts
 *
 * These are specific to rows in template
 */

// Row News Financial Results Event
jq(document).ready(function () {
    // Scroll more home hero button
    let scrollMore = document.getElementById("scroll-more-midtown");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            let target = jq("#scroll-more-anchor");
            jq("html,body").animate(
                {
                    scrollTop: target.offset().top - jq("#site-header").height(),
                },
                "slow"
            );
        });
    }
});

/**
 * Footnotes Functionality — temporarily disabled.
 * Linking is handled by files/theme/js/site.js.
 *
 * Original implementation preserved below.
 */
if (false) {
/**
 * Footnotes Functionality
 *
 * CMS markers in stat/table copy:
 * - {{*}}  -> superscript link to a paragraph footnote starting with *
 * - {{1}}  -> superscript link to the first li in a footnotes ol
 * - {{1,2}} -> superscript links to footnotes 1 and 2, comma preserved between them 
 */
const FOOTNOTE_CONTAINER_SELECTOR = '.financial-disclaimer, .source, .footnotes .text, .timeline-footnote, .operating-performance-guidance__footnotes .text';
const FOOTNOTE_OL_SELECTOR = '.financial-disclaimer ol, .source ol, .footnotes .text ol, .timeline-footnote ol, .operating-performance-guidance__footnotes ol';
const FOOTNOTE_CONTENT_SELECTOR = '.stat p, .stat-box p, .stat .description, .stat--value, .stat--title, th, td, .project-parameters__label, .project-parameters__description, .row-content-block .text h2, .row-content-block .text h3, .row-content-block .text h4, .row-content-block .text p, .row-content-block .text li, .row-content-block .text dd, .module-stats .module-content .text h2, .module-stats .module-content .text h3, .module-timeline .content, .module-timeline .timeline-heading';
const MAIN_CONTENT_FOOTNOTE_SELECTOR = '.main-content th, .main-content td, .main-content p, .main-content li, .main-content h2, .main-content h3, .main-content h4, .main-content dd';
const FOOTNOTE_TARGET_SELECTOR = '.stat, .stat-box, th[scope="row"], .project-parameters__label, .project-parameters__description, .row-content-block .text, .module-timeline .content';
const createSuperscriptLink = (id, display = '*') =>
    `<a href="#footnoteDesc${id}" aria-describedby="footnoteDesc${id}" tabindex="0" data-footnote="${id}" class="span-asterisk"><sup>${display}</sup></a>`;

let footnoteCounter = 0;

function shouldSkipFootnoteContent(element) {
    if (element.closest('.footnotes .text, .financial-disclaimer')) {
        return true;
    }

    if (element.matches('ol, li') && element.closest(FOOTNOTE_CONTAINER_SELECTOR)) {
        return true;
    }

    return false;
}

function processOlFootnotes(ol) {
    const mapping = {};

    ol.querySelectorAll(':scope > li').forEach((li, index) => {
        const markerNum = index + 1;
        const existingMatch = li.id && li.id.match(/^footnoteDesc(\d+)$/);
        let id;

        if (existingMatch) {
            id = parseInt(existingMatch[1], 10);
            footnoteCounter = Math.max(footnoteCounter, id);
        } else {
            id = ++footnoteCounter;
            li.id = `footnoteDesc${id}`;
            li.classList.add('footnote-desc');
            li.setAttribute('aria-label', `Footnote ${markerNum}`);
            li.setAttribute('tabindex', '0');
        }

        mapping[markerNum] = id;
    });

    return mapping;
}

function resolveFootnoteId(num, olMapping) {
    if (!olMapping || Object.keys(olMapping).length === 0) {
        return null;
    }

    if (olMapping[num]) {
        return olMapping[num];
    }

    let nearestKey = null;
    let nearestDistance = null;

    Object.keys(olMapping).forEach((key) => {
        const markerNum = parseInt(key, 10);
        const distance = Math.abs(markerNum - num);
        if (nearestDistance === null || distance < nearestDistance) {
            nearestDistance = distance;
            nearestKey = markerNum;
        }
    });

    return nearestKey !== null ? olMapping[nearestKey] : null;
}

function replaceFootnoteMarkers(element, olMapping, asteriskFootnoteId) {
    if (!element.innerHTML.includes('{{')) {
        return;
    }

    element.innerHTML = element.innerHTML.replace(/\{\{(\d+(?:\s*,\s*\d+)*)\}\}/g, (match, group) => {
        const numbers = group.match(/\d+/g);

        if (!numbers) {
            return match;
        }

        const links = numbers.map((numStr) => {
            const num = parseInt(numStr, 10);
            const footnoteId = resolveFootnoteId(num, olMapping);

            return footnoteId ? createSuperscriptLink(footnoteId, String(num)) : null;
        }).filter(Boolean);

        if (!links.length) {
            return match;
        }

        return links.join(',');
    });

    if (element.innerHTML.includes('{{*}}')) {
        const asteriskId = asteriskFootnoteId || resolveFootnoteId(1, olMapping);
        if (asteriskId) {
            element.innerHTML = element.innerHTML.replace(/\{\{\*\}\}/g, createSuperscriptLink(asteriskId, '*'));
        }
    }
}

function getFootnoteModuleRoot(section) {
    return section.closest('.module, section.module, .row-project-parameters') || section;
}

function isFootnoteModuleElement(element) {
    if (!element || element.nodeType !== 1) {
        return false;
    }

    return element.classList.contains('module') || element.classList.contains('row-project-parameters');
}

function collectFootnoteGroup(moduleRoot) {
    const modules = [moduleRoot];
    let previous = moduleRoot.previousElementSibling;

    while (isFootnoteModuleElement(previous)) {
        const hasTargets = previous.querySelector(FOOTNOTE_TARGET_SELECTOR);
        const hasFootnotes = previous.querySelector(FOOTNOTE_CONTAINER_SELECTOR);

        if (hasTargets && !hasFootnotes) {
            modules.unshift(previous);
            previous = previous.previousElementSibling;
        } else {
            break;
        }
    }

    return modules;
}

function processFootnotesInGroup(modules) {
    let olMapping = {};

    modules.forEach((moduleRoot) => {
        moduleRoot.querySelectorAll(FOOTNOTE_OL_SELECTOR).forEach((ol) => {
            if (ol.closest('.module-timeline')) {
                return;
            }

            olMapping = { ...olMapping, ...processOlFootnotes(ol) };
        });
    });

    let asteriskFootnoteId = null;

    modules.forEach((moduleRoot) => {
        moduleRoot.querySelectorAll('.financial-disclaimer .financial-text p, .source p, .footnotes .text p').forEach((footnote) => {
            if (footnote.closest('.module-timeline')) {
                return;
            }

            if (!footnote.textContent.trim().startsWith('*')) {
                return;
            }

            const existingMatch = footnote.id && footnote.id.match(/^footnoteDesc(\d+)$/);
            if (existingMatch) {
                asteriskFootnoteId = parseInt(existingMatch[1], 10);
                footnoteCounter = Math.max(footnoteCounter, asteriskFootnoteId);
                return;
            }

            asteriskFootnoteId = ++footnoteCounter;
            footnote.outerHTML = `<p id="footnoteDesc${asteriskFootnoteId}" class="footnote-desc" aria-label="Footnote" role="status" tabindex="0">${footnote.innerHTML}</p>`;
        });
    });

    modules.forEach((moduleRoot) => {
        moduleRoot.querySelectorAll(FOOTNOTE_CONTENT_SELECTOR).forEach((element) => {
            if (shouldSkipFootnoteContent(element)) {
                return;
            }

            replaceFootnoteMarkers(element, olMapping, asteriskFootnoteId);
        });
    });
}

function processFootnotesInSection(section) {
    processFootnotesInGroup([getFootnoteModuleRoot(section)]);
}

function processTimelineFootnotes() {
    document.querySelectorAll('.module-timeline').forEach((module) => {
        const section = module.querySelector('.container') || module;
        const footnoteContainer = section.querySelector('.timeline-footnote');

        if (!footnoteContainer) {
            return;
        }

        let olMapping = {};

        footnoteContainer.querySelectorAll('ol').forEach((ol) => {
            olMapping = { ...olMapping, ...processOlFootnotes(ol) };
        });

        let asteriskFootnoteId = null;

        footnoteContainer.querySelectorAll('ol > li').forEach((li) => {
            if (!li.textContent.trim().startsWith('*')) {
                return;
            }

            const id = parseInt(li.id.replace('footnoteDesc', ''), 10);
            if (!Number.isNaN(id)) {
                asteriskFootnoteId = id;
            }
        });

        footnoteContainer.querySelectorAll('p').forEach((footnote) => {
            if (!footnote.textContent.trim().startsWith('*')) {
                return;
            }

            asteriskFootnoteId = ++footnoteCounter;
            footnote.outerHTML = `<p id="footnoteDesc${asteriskFootnoteId}" class="footnote-desc" aria-label="Footnote" role="status" tabindex="0">${footnote.innerHTML}</p>`;
        });

        section.querySelectorAll('.point .content').forEach((element) => {
            replaceFootnoteMarkers(element, olMapping, asteriskFootnoteId);
        });
    });
}

function processAllFootnotes() {
    const processedModules = new Set();

    document.querySelectorAll('.module-stats > .container, .container').forEach((section) => {
        if (section.closest('.operating-performance-guidance')) {
            return;
        }

        const moduleRoot = getFootnoteModuleRoot(section);
        if (processedModules.has(moduleRoot)) {
            return;
        }

        const hasFootnoteContent = section.querySelector('.source, .financial-disclaimer, .footnotes, .timeline-footnote');
        const hasFootnoteTargets = section.querySelector(FOOTNOTE_TARGET_SELECTOR);

        if (!hasFootnoteContent || !hasFootnoteTargets) {
            return;
        }

        const group = collectFootnoteGroup(moduleRoot);
        group.forEach((module) => processedModules.add(module));
        processFootnotesInGroup(group);
    });
}

function processMainContentFootnotes() {
    document.querySelectorAll('.main-content').forEach((mainContent) => {
        if (!mainContent.innerHTML.includes('{{')) {
            return;
        }

        const footnoteLists = mainContent.querySelectorAll('ol');
        if (!footnoteLists.length) {
            return;
        }

        const footnoteOl = footnoteLists[footnoteLists.length - 1];
        const olMapping = processOlFootnotes(footnoteOl);

        mainContent.querySelectorAll(MAIN_CONTENT_FOOTNOTE_SELECTOR).forEach((element) => {
            if (element.closest('ol') === footnoteOl) {
                return;
            }

            if (shouldSkipFootnoteContent(element)) {
                return;
            }

            replaceFootnoteMarkers(element, olMapping, null);
        });
    });
}

function processOperatingPerformanceGuidanceFootnotes() {
    document.querySelectorAll('.operating-performance-guidance').forEach((module) => {
        const section = module.querySelector('.container');
        if (!section) {
            return;
        }

        const hasTableContent = section.querySelector('th[scope="row"], td strong');
        if (!hasTableContent) {
            return;
        }

        let footnoteOl = section.querySelector('.operating-performance-guidance__footnotes ol');

        if (!footnoteOl) {
            const nextModule = module.nextElementSibling;
            if (nextModule?.classList.contains('row-content-block')) {
                footnoteOl = nextModule.querySelector('.text ol');
            }
        }

        if (!footnoteOl) {
            return;
        }

        const olMapping = processOlFootnotes(footnoteOl);

        section.querySelectorAll('th[scope="row"], td').forEach((element) => {
            if (shouldSkipFootnoteContent(element)) {
                return;
            }

            replaceFootnoteMarkers(element, olMapping, null);
        });
    });
}

function initMetricsStatsFootnotesCollapse() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('.metrics-stats-footnotes a.span-asterisk');
        if (!link) {
            return;
        }

        const module = link.closest('.metrics-stats-footnotes');
        const collapsePanel = module?.querySelector('.footnotes .panel-collapse.collapse');
        if (!module || !collapsePanel) {
            return;
        }

        event.preventDefault();

        const hash = link.getAttribute('href');
        const scrollToFootnote = () => {
            if (hash && hash.startsWith('#')) {
                smoothScrollToHash(hash);
                const target = document.querySelector(hash);
                if (target) {
                    target.focus({ preventScroll: true });
                }
            }
        };

        if (collapsePanel.classList.contains('show')) {
            scrollToFootnote();
            return;
        }

        const accordionBtn = module.querySelector('.footnotes .accordion-btn');
        const handleShown = () => {
            collapsePanel.removeEventListener('shown.bs.collapse', handleShown);
            scrollToFootnote();
        };

        collapsePanel.addEventListener('shown.bs.collapse', handleShown);

        if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
            bootstrap.Collapse.getOrCreateInstance(collapsePanel, { toggle: false }).show();
        } else {
            collapsePanel.classList.add('show');
            handleShown();
        }

        if (accordionBtn) {
            accordionBtn.classList.remove('collapsed');
            accordionBtn.setAttribute('aria-expanded', 'true');
        }
    });
}

function initFootnotes() {
    processAllFootnotes();
    processMainContentFootnotes();
    processOperatingPerformanceGuidanceFootnotes();
    processTimelineFootnotes();
    initMetricsStatsFootnotesCollapse();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFootnotes);
} else {
    initFootnotes();
}
}

/**
 * Adjusts the scroll position to ensure the focused element is visible within the viewport.
 *
 * The function checks if the element is above the visible area or below the viewport,
 * and if so, it adjusts the scroll position to bring the element into view with extra space.
 */
function adjustScrollPosition(e) {
    const headerHeight = document.querySelector("#site-header").offsetHeight;
    const extraSpace = 80;
    const totalHeight = headerHeight + extraSpace;
    const elementTop = e.target.getBoundingClientRect().top;
    const elementBottom = e.target.getBoundingClientRect().bottom;

    let is_affixed = jq(e.target).closest(".affixed").length;

    if (!is_affixed && (elementTop < totalHeight || elementBottom > window.innerHeight)) {
        window.scrollTo({
            top: elementTop + window.scrollY - totalHeight,
            behavior: "smooth",
        });
    }
}

document.addEventListener("keydown", (e) => {
    if (e.key === "Tab" && e.shiftKey) {
        document.addEventListener("focusin", adjustScrollPosition);
    } else {
        document.removeEventListener("focusin", adjustScrollPosition);
    }
});

/**
 * Dynamically wrap tables inside news articles utilizing the Table Wrapper library
 */
document.querySelectorAll(".full-news-article table, .financials table").forEach((table, index) => {
  // Create the parent wrapper
  const parentWrapper = document.createElement("div");
  parentWrapper.className = "tw-parent";
  parentWrapper.setAttribute("data-aria-label", `Table ${index + 1}`);

  // Wrap the table inside the parent wrapper
  table.parentNode.insertBefore(parentWrapper, table);
  parentWrapper.appendChild(table);
});

/**
 * Enables keyboard navigation for tabs within a .tab-header element.
 *
 * Key Features:
 * - Navigation wraps around when reaching the first or last tab.
 * - Focus is moved to the new tab, and the `click` event is triggered to activate it.
 * - Prevents default behavior for smoother keyboard interactions.
 */
document.addEventListener('keydown', (event) => {
    // Check if the focus is inside a .tab-header element
    const activeTab = document.activeElement.closest('.tab-header .nav-link');
    if (!activeTab) return;

    const tabHeader = activeTab.closest('.tab-header');
    const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
    const currentIndex = tabs.indexOf(activeTab);

    let newIndex = -1;

    if (event.key === 'ArrowRight') {
        // Move to the next tab
        newIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
        // Move to the previous tab
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    }

    if (newIndex >= 0) {
        event.preventDefault();
        // Activate the new tab
        const newTab = tabs[newIndex];
        newTab.focus();
        newTab.click();
    }
});

/**
 * Enables keyboard activation of CTA Email Alert buttons.
 *
 * It should work with both space and enter keys
 */
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a.email-alerts-btn');
  links.forEach(function (link) {
    link.addEventListener('keydown', function (event) {
      if (event.key === ' ' || event.key === 'Spacebar') { // Spacebar for older browsers
        event.preventDefault(); // Prevent page scroll
        link.click();
      }
    });
  });
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// This replaces the jquery-match-height that has a CSP unsafe-inline conflict
// Collect elements into groups based on data-mh attribute
// using style property directly is compliant with CSP style-src directive
function updateMatchedHeights() {
    const groups = {};
    if (document.querySelectorAll('[data-mh]').length < 1) {
        return;
    }
    // Collect elements into groups based on data-mh attribute
    document.querySelectorAll('[data-mh]').forEach(el => {
        const groupName = el.getAttribute('data-mh');

        if (!groups[groupName]) {
            groups[groupName] = [];
        }

        groups[groupName].push(el);
    });

    // Reset heights before recalculating
    Object.values(groups).forEach(group => {
        group.forEach(el => el.style.height = 'auto');
    });

    // Find the tallest element in each group and apply that height to all members
    Object.values(groups).forEach(group => {
        const maxHeight = Math.max(...group.map(el => el.offsetHeight));
        group.forEach(el => el.style.height = `${maxHeight}px`);
    });
}

jq(window).on('load resize', updateMatchedHeights);

// This replaces the pipeline inline styles on the page that has conflicts with the CSP
// using style property directly is compliant with CSP style-src directive
function updatePipelineStyles() {
    if (document.querySelector('.pipeline-module')) {
        const pipelineModules = document.querySelectorAll('.pipeline-module');
        pipelineModules.forEach(module => {
            const statuses = module.querySelectorAll('.status');
            statuses.forEach(status => {
                const width = status.getAttribute('data-width');
                if (width) {
                    status.style.width = `${width}%`;
                }
            });
        });
    }
}

jq(window).on('load', updatePipelineStyles);

/**
 * Enhanced Tab Navigation for Row-Tabs Component
 * 
 * This script provides comprehensive keyboard navigation for tab components:
 * - Tab key navigation within tab panels
 * - Automatic progression to next tab when current panel content is exhausted
 * - Proper focus management and accessibility
 */

// Enhanced Tab Navigation Functions
function initTabNavigation() {
    // Inner quote/historical tabs (.tabs-box) and the outer exchange switcher
    // (.stock-ticker-tabs) both need inert sync on hidden panels.
    document.querySelectorAll('.tabs-box, .stock-ticker-tabs').forEach(function(container) {
        setupTabNavigation(container);
    });
}

function setupTabNavigation(container) {
    const tabHeader = container.querySelector(':scope > .tab-header') || container.querySelector('.tab-header');
    const tabContent = container.querySelector(':scope > .tab-content') || container.querySelector('.tab-content');
    
    if (!tabHeader || !tabContent) return;

    const tabList = tabHeader.querySelector('[role="tablist"]');
    const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
    // Direct children only so nested ticker → quote/historical panes stay independent.
    const tabPanels = Array.from(tabContent.children).filter(function(el) {
        return el.classList && el.classList.contains('tab-pane');
    });
    
    container._tabs = tabs;
    container._tabPanels = tabPanels;
    
    const activeTab = tabHeader.querySelector('.nav-link.active');
    container._currentTabIndex = activeTab ? tabs.indexOf(activeTab) : 0;

    if (tabList && !tabList.hasAttribute('aria-labelledby') && !tabList.hasAttribute('aria-label')) {
        const moduleContainer = container.closest('.container');
        const sectionHeading = moduleContainer ? moduleContainer.querySelector('.module-content h2, .module-content h3') : null;
        if (sectionHeading) {
            if (!sectionHeading.id) {
                sectionHeading.id = 'tablist-label-' + Math.random().toString(36).slice(2, 9);
            }
            tabList.setAttribute('aria-labelledby', sectionHeading.id);
        }
    }

    tabs.forEach(function(tab, index) {
        if (!tab.id) {
            const panelId = tab.getAttribute('aria-controls');
            tab.id = panelId ? 'btn-' + panelId : 'tab-btn-' + index;
        }
        const panel = tabPanels[index];
        if (panel && !panel.hasAttribute('aria-labelledby')) {
            panel.setAttribute('aria-labelledby', tab.id);
        }
    });

    syncTabPanelAccessibility(container);

    tabs.forEach(function(tab) {
        tab.setAttribute('tabindex', '-1');
    });
    const initialActive = tabHeader.querySelector('.nav-link.active') || tabs[0];
    if (initialActive) {
        initialActive.setAttribute('tabindex', '0');
    }

    tabHeader.addEventListener('shown.bs.tab', function() {
        syncTabPanelAccessibility(container);
    });

    container.addEventListener('keydown', function(event) {
        handleTabNavigation(event, container);
    });

    tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
            container._currentTabIndex = index;
            tabs.forEach(function(t) { t.setAttribute('tabindex', '-1'); });
            tab.setAttribute('tabindex', '0');
        });
    });
}

function syncTabPanelAccessibility(container) {
    const tabPanels = container._tabPanels;
    if (!tabPanels) return;

    tabPanels.forEach(function(panel) {
        const isActive = panel.classList.contains('active');

        panel.setAttribute('tabindex', isActive ? '0' : '-1');
        // inert removes the subtree from the a11y tree and from the tab order.
        // Do not use aria-hidden here: QMod injects native controls (select /
        // input / button) that stay natively focusable even with tabindex="-1",
        // which fails axe aria-hidden-focus / focusable-disabled.
        panel.toggleAttribute('inert', !isActive);
        panel.removeAttribute('aria-hidden');
    });
}

function syncAllTabPanelAccessibility() {
    document.querySelectorAll('.tabs-box, .stock-ticker-tabs').forEach(function(container) {
        if (container._tabPanels) {
            syncTabPanelAccessibility(container);
        }
    });
}
window.syncAllTabPanelAccessibility = syncAllTabPanelAccessibility;

function handleTabNavigation(event, container) {
    if (event.key !== 'Tab') return;

    const tabs = container._tabs;
    const tabPanels = container._tabPanels;

    if (!tabs || !tabPanels) return;

    const activeElement = document.activeElement;

    const currentPanel = Array.from(tabPanels).find(panel => panel.contains(activeElement));
    if (!currentPanel) return;

    const currentTabIndex = tabPanels.indexOf(currentPanel);
    if (currentTabIndex === -1) return;

    const isPanelFocused = activeElement === currentPanel;
    const focusableElements = getFocusableElementsInTab(currentPanel);
    const currentFocusIndex = isPanelFocused ? -1 : focusableElements.indexOf(activeElement);

    if (!event.shiftKey) {
        if (isPanelFocused) {
            if (focusableElements.length === 0 && currentTabIndex < tabs.length - 1) {
                event.preventDefault();
                switchToTabEnhanced(container, currentTabIndex + 1);
            }
        } else if (currentFocusIndex === focusableElements.length - 1) {
            if (currentTabIndex < tabs.length - 1) {
                event.preventDefault();
                switchToTabEnhanced(container, currentTabIndex + 1);
            }
        }
    } else {
        if (isPanelFocused || currentFocusIndex === 0) {
            event.preventDefault();
            tabs[currentTabIndex].focus();
        }
    }
}

function switchToTabEnhanced(container, tabIndex, focusTab = true) {
    const tabs = container._tabs;
    const tabPanels = container._tabPanels;
    
    if (!tabs || !tabPanels || tabIndex < 0 || tabIndex >= tabs.length) return;

    container._currentTabIndex = tabIndex;

    tabs.forEach(function(tab) {
        tab.classList.remove('active');
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
    });
    
    tabPanels.forEach(function(panel) {
        panel.classList.remove('show', 'active');
    });

    const newTab = tabs[tabIndex];
    const newPanel = tabPanels[tabIndex];
    
    newTab.classList.add('active');
    newTab.setAttribute('aria-selected', 'true');
    newTab.setAttribute('tabindex', '0');
    newPanel.classList.add('show', 'active');
    syncTabPanelAccessibility(container);

    if (focusTab) {
        newTab.focus();
    }
}

function getFocusableElementsInTab(container) {
    const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
        'area[href]',
        'iframe',
        'object',
        'embed'
    ].join(', ');

    return Array.from(container.querySelectorAll(focusableSelectors))
        .filter(function(element) {
            if (element.closest('[inert]')) {
                return false;
            }
            const style = window.getComputedStyle(element);
            return style.display !== 'none' && 
                   style.visibility !== 'hidden' && 
                   !element.hasAttribute('aria-hidden');
        });
}

// Reflow QMod/Highcharts charts when a hidden stock-ticker tab is revealed.
// Charts rendered inside a display:none tab initialize at zero width, so we
// nudge a window resize once the ticker's tab is shown.
function initStockTickerTabs() {
    document.querySelectorAll('.stock-ticker-tabs').forEach(function (wrapper) {
        wrapper.addEventListener('shown.bs.tab', function () {
            window.dispatchEvent(new Event('resize'));
        });
    });
}

jq(document).ready(function () {
    initEmbeddedVideoFacades();
    initEmbeddedVideoIframeTitles();
    initTabNavigation();
    initStockTickerTabs();
    initPremierAssetsMap();
});

/**
 * Load YouTube/Vimeo iframes on user activation so third-party markup is not
 * present during initial page load or automated accessibility scans.
 */
function initEmbeddedVideoFacades() {
    document.querySelectorAll('.embed-container--facade .embed-container__poster[data-embed-src]').forEach(function (button) {
        if (button.dataset.facadeBound === 'true') {
            return;
        }

        button.dataset.facadeBound = 'true';

        button.addEventListener('click', function () {
            const container = button.closest('.embed-container');
            const src = button.getAttribute('data-embed-src');
            const title = button.getAttribute('data-embed-title') || 'Video player';
            const iframe = document.createElement('iframe');

            iframe.setAttribute('src', src);
            iframe.setAttribute('title', title);
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            iframe.setAttribute('allowfullscreen', '');

            container.classList.remove('embed-container--facade');
            container.replaceChildren(iframe);
        });
    });
}

/**
 * Ensure embedded YouTube/Vimeo iframes have an accessible name (WCAG frame-title).
 */
function initEmbeddedVideoIframeTitles() {
    document.querySelectorAll('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo.com/video"]').forEach(function (iframe) {
        if (iframe.getAttribute('title')) {
            return;
        }

        const src = iframe.getAttribute('src') || '';
        iframe.setAttribute('title', src.indexOf('player.vimeo.com') !== -1 ? 'Vimeo video player' : 'YouTube video player');
    });
}

/**
 * Premier Assets map row — nav buttons / markers switch active location panel + map highlights.
 */
function initPremierAssetsMap() {
    document.querySelectorAll('.row-premier-assets-map').forEach(function (row) {
        if (row.classList.contains('map-overview')) {
            return;
        }

        const isSingle = row.classList.contains('single');
        const navButtons = Array.from(row.querySelectorAll('.premier-map__nav-btn[data-map-key]'));
        const panels = Array.from(row.querySelectorAll('.premier-map__panel[data-map-panel]'));
        const markers = Array.from(row.querySelectorAll('.premier-map__marker[data-location]'));
        const embeddedMarkers = Array.from(row.querySelectorAll('.premier-map__embedded-marker[data-location]'));
        const overlay = row.querySelector('.premier-map__overlay');
        // Below this width the button row is the control; at/above it the on-map
        // name pills are the tablist. Keep in sync with the `lg` SCSS breakpoint.
        const desktopMq = window.matchMedia('(min-width: 992px)');

        function normalizeMapKey(key) {
            return String(key || '')
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '');
        }

        function mapKeysMatch(a, b) {
            return normalizeMapKey(a) === normalizeMapKey(b);
        }

        function activateLocation(mapKey, focusPanelTitle) {
            if (!mapKey) {
                return;
            }

            row.setAttribute('data-active-location', normalizeMapKey(mapKey));

            navButtons.forEach(function (button) {
                const isActive = mapKeysMatch(button.dataset.mapKey, mapKey);
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-selected', isActive ? 'true' : 'false');
                button.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            panels.forEach(function (panel) {
                const isActive = mapKeysMatch(panel.dataset.mapPanel, mapKey);
                panel.classList.toggle('is-active', isActive);
                if (isActive) {
                    panel.removeAttribute('hidden');
                } else {
                    panel.setAttribute('hidden', '');
                }
            });

            markers.forEach(function (marker) {
                const isActive = mapKeysMatch(marker.dataset.location, mapKey);
                marker.classList.toggle('is-active', isActive);
                if (marker.getAttribute('role') === 'tab') {
                    marker.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    marker.setAttribute('tabindex', (desktopMq.matches && isActive) ? '0' : '-1');
                }
            });

            embeddedMarkers.forEach(function (marker) {
                marker.classList.toggle('is-active', mapKeysMatch(marker.dataset.location, mapKey));
            });

            if (focusPanelTitle && panels.length) {
                const activePanel = panels.find(function (panel) {
                    return mapKeysMatch(panel.dataset.mapPanel, mapKey);
                });
                if (activePanel) {
                    const panelTitle = activePanel.querySelector('.premier-map__panel-title');
                    if (panelTitle) {
                        panelTitle.focus();
                    }
                }
            }
        }

        if (isSingle) {
            const initialKey = row.getAttribute('data-active-location');
            if (initialKey) {
                activateLocation(initialKey, false);
            }
            return;
        }

        if (!navButtons.length || !panels.length) {
            return;
        }

        navButtons.forEach(function (button, index) {
            button.addEventListener('click', function () {
                activateLocation(button.dataset.mapKey, true);
            });

            button.addEventListener('keydown', function (event) {
                let targetIndex = index;

                if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    targetIndex = (index + 1) % navButtons.length;
                    event.preventDefault();
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                    targetIndex = (index - 1 + navButtons.length) % navButtons.length;
                    event.preventDefault();
                } else if (event.key === 'Home') {
                    targetIndex = 0;
                    event.preventDefault();
                } else if (event.key === 'End') {
                    targetIndex = navButtons.length - 1;
                    event.preventDefault();
                } else {
                    return;
                }

                activateLocation(navButtons[targetIndex].dataset.mapKey, true);
            });
        });

        const tabMarkers = markers.filter(function (marker) {
            return marker.getAttribute('role') === 'tab';
        });

        tabMarkers.forEach(function (marker, index) {
            marker.addEventListener('click', function () {
                activateLocation(marker.dataset.location, false);
            });

            marker.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                    event.preventDefault();
                    activateLocation(marker.dataset.location, false);
                    return;
                }

                let targetIndex = index;

                if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    targetIndex = (index + 1) % tabMarkers.length;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                    targetIndex = (index - 1 + tabMarkers.length) % tabMarkers.length;
                } else if (event.key === 'Home') {
                    targetIndex = 0;
                } else if (event.key === 'End') {
                    targetIndex = tabMarkers.length - 1;
                } else {
                    return;
                }

                event.preventDefault();
                const target = tabMarkers[targetIndex];
                activateLocation(target.dataset.location, false);
                target.focus();
            });
        });

        function applyBreakpointState() {
            if (overlay) {
                // On mobile the button row is the control, so the SVG tablist is
                // hidden from assistive tech to avoid duplicate navigation.
                overlay.setAttribute('aria-hidden', desktopMq.matches ? 'false' : 'true');
            }
            activateLocation(row.getAttribute('data-active-location') || navButtons[0].dataset.mapKey, false);
        }

        applyBreakpointState();

        if (desktopMq.addEventListener) {
            desktopMq.addEventListener('change', applyBreakpointState);
        } else if (desktopMq.addListener) {
            desktopMq.addListener(applyBreakpointState);
        }
    });
}
